import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context'
import App from './App.tsx'
import './styles/globals.css'
// Import i18n instance
import './i18n/i18n'
// Import auth configuration
import { oidcConfig } from './config/auth-config'
import { AuthProvider } from './context/auth-context'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <OidcAuthProvider {...oidcConfig}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </OidcAuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)